import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'מהי חובת הליווי לאחר קבלת הרשיון?',
      answer: 'חובת הליווי לנהגים חדשים מתחת לגיל 24 נמשכת חצי שנה. בשלושת החודשים הראשונים הליווי נדרש בכל שעות היום, ובשלושת החודשים הבאים הוא נדרש רק בלילה. בסיום תקופה זו, יש להצהיר על השלמת 50 שעות נהיגה עם מלווה מנוסה כדי לקבל את רישיון הנהיגה הקבוע.'
    },
    {
      question: 'מהו הגיל המינימלי להתחלת לימוד נהיגה ולהוצאת רשיון?',
      answer: 'בישראל ניתן להתחיל ללמוד נהיגה כבר מגיל 16.5 (16 שנים ו־6 חודשים), אך לגשת לטסט המעשי רק מגיל 16 שנים ו־9 חודשים.'
    },
    {
      question: 'כמה שיעורים צריך כדי לגשת לטסט?',
      answer: 'החוק בישראל מחייב 28 שיעורים מעשיים מינימום לפני הגשת מועמדות לטסט.'
    },
    {
      question: 'איזה מסמכים דרושים כדי להתחיל בשיעורי הנהיגה?',
      answer: 'לפני תחילת הלימוד יש להנפיק טופס ירוק רפואי המעיד על כשירות לנהיגה, ולעבור מבחן עיניים– אלו תנאים קדם הכרחיים להתחלה.'
    },
    {
      question: 'כמה זמן תקופת "נהג חדש" נמשכת לאחר קבלת רשיון הנהיגה?',
      answer: 'נהגים חדשים בישראל נפגשים בתקנות מיוחדות, כאשר תקופת ההגבלה ממשיכה עד שיהיה להם שנתיים רישיון (או יותר, אם נעשו עבירות).'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section faq">
      <div className="container">
        <h2 className="section-title progressive-element">תשובות לשאלות נפוצות</h2>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item stagger-${index + 1} ${openIndex === index ? 'open' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <svg 
                  className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="currentColor"
                >
                  <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/>
                </svg>
              </button>
              
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
